import React from 'react'
import { ChartSkeletonBase } from './ChartSkeletonBase'

export const LineChartSkeleton: React.FC<{
  loading?: boolean
  progress?: number
  height?: number
  progressDetails?: React.ReactElement
  showLoadingPercent?: boolean
  hideLoadingSpinner?: boolean
}> = props => {
  return <ChartSkeletonBase {...props} getBarHeight={(index, height) => Math.cos(index - 1) * (height ?? 150)} />
}
